'use strict';

wbApp.factory('coursePriceSvc', ['tenantSettingSvc', '$filter', '$translate',
    function (tenantSettingSvc, $filter, $translate) {

        function getPriceStr(finalPrice, remainingLessons, discountAmt, showNoOfLessons) {
            if (showNoOfLessons) {
                if (discountAmt) {
                    return '{0} ({1} {2}, {3} {4})'.f(
                        $filter('wbCurrencyFlt')(finalPrice),
                        remainingLessons,
                        $translate.instant('TXT_COL_LESSONS'),
                        $filter('wbCurrencyFlt')(discountAmt),
                        $translate.instant('TXT_COL_DISCOUNT'));
                } else {
                    return '{0} ({1} {2})'.f(
                        $filter('wbCurrencyFlt')(finalPrice),
                        remainingLessons,
                        $translate.instant('TXT_COL_LESSONS'));
                }
            } else {
                if (discountAmt) {
                    return '{0} ({1} {2})'.f(
                        $filter('wbCurrencyFlt')(finalPrice),
                        $filter('wbCurrencyFlt')(discountAmt),
                        $translate.instant('TXT_COL_DISCOUNT'));
                } else {
                    return $filter('wbCurrencyFlt')(finalPrice);
                }
            }
        }

        function getCourseFeeLineName(course, noOfLessons, useAmortizationSchedule) {
            if (course.fixedPrice !== null && course.fixedPrice !== undefined) {
                return '{0} ({1})'.f(
                    $translate.instant('TXT_LBL_COURSE_FEE'),
                    $translate.instant('TXT_LBL_FIXED_PRICE'));
            } else {
                var factor = !!useAmortizationSchedule
                    ? (course.amortizationScheduleSurchargePct / 100) + 1
                    : 1;

                return '{0} ({1} x {2})'.f(
                    $translate.instant('TXT_LBL_COURSE_FEE'),
                    noOfLessons,
                    $filter('wbCurrencyFlt')(_.round(course.price * factor, 2))
                );
            }
        }


        function findStudentAttendance(attendance, studentID) {
            if (!attendance || attendance.length === 0) {
                return null;
            }

            for (var s = 0; s < attendance.length; s++) {
                var studentAtt = attendance[s];
                if (studentAtt.studentID === studentID) {
                    return studentAtt;
                }
            }

            return null;
        }

        function calcRemainingPaidAttendance(scheduleWithAttendance, studentID, remainingLessons) {
            if (!scheduleWithAttendance || scheduleWithAttendance.length === 0) {
                return remainingLessons;
            }

            var cnt = 0;

            for (var l = 0; l < scheduleWithAttendance.length; l++) {
                var lesson = scheduleWithAttendance[l];
                var studentAtt = findStudentAttendance(lesson.attendance, studentID);

                if ((studentAtt && 
                     studentAtt.courseAttendanceFeeType !== null &&
                     studentAtt.courseAttendanceFeeType !== 1 && // OneOff
                     studentAtt.courseAttendanceFeeType !== 2 // None
                    ) ||
                    (studentAtt === null) ||
                    (studentAtt !== null && studentAtt.courseAttendanceFeeType === null)
                   ) {
                    cnt++;
                }
            }

            return cnt;
        }

        // Expects:
        // course { 
        //  price: 0, 
        //  fixedPrice: 0, ,
        //  remainingLessons: 0, 
        //  scheduleWithAttendance: [ 
        //      { 
        //          courseScheduleID: 0,
        //          attendance: [ { studentID: 0, courseAttendanceFeeType: 0 } ]
        //      } 
        //  ] }
        // student { studentID: 0, promotions: [] }
        function getPriceDetails(course, student, isAction) {
            
            var basePrice = getCourseBasePrice(
                course,
                calcRemainingPaidAttendance(course.scheduleWithAttendance, student.studentID, course.remainingLessons),
                student.attendanceCount);

            var finalPriceWithoutDiscounts = basePrice;
            var discountPct = 0;

            angular.forEach(student.promotions, function (promotion) {
                // promotions which we do not own but are going to buy
                // so we need to add their price
                if (!promotion.owns &&
                    (promotion.isMandatory || promotion.buy)) {
                    finalPriceWithoutDiscounts += promotion.price;
                }

                if (promotion.owns || promotion.isMandatory || promotion.buy) {
                    discountPct += promotion.discountPct;
                }
            });

            // Calculate discount amount
            var discountAmt = (basePrice * discountPct) / 100;
            var finalPrice = finalPriceWithoutDiscounts - discountAmt;

            return {
                basePrice: basePrice,
                discountAmt: discountAmt,
                finalPrice: finalPrice,
                finalPriceStr: getPriceStr(
                    finalPrice,
                    course.remainingLessons,
                    discountAmt,
                    !course.fixedPrice && !isAction)
            };
        }


        // course { 
        //   price: 0, 
        //   fixedPrice: 0,
        //   amortizationScheduleSurchargePct: 0
        // }
        // remainingLessons: 0
        // attendanceCount: 1     - for actions,
        // useAmortizationSchedule: [true|false]
        function getCourseBasePrice(course, remainingLessons, attendanceCount, useAmortizationSchedule) {

            var basePrice = 0;

            if (course.fixedPrice !== null && course.fixedPrice !== undefined) { // 0 is valid price
                basePrice = course.fixedPrice;
            } else {
                if (course.subjectCategoryID === 2) {
                    // Action
                    basePrice = course.price;
                } else {
                    basePrice = remainingLessons * course.price;
                }
            }

            basePrice = basePrice * (attendanceCount || 1);

            if (!!useAmortizationSchedule) {
                var factor = (course.amortizationScheduleSurchargePct / 100) + 1;
                basePrice = basePrice * factor;
            }

            return _.round(basePrice, 2);
        }

        function gtDiscountLineStr(promotionName, discountPct) {
            return $translate.instant('TXT_LBL_DISCOUNT_PCT') + ' - {0} ({1} %)'.f(promotionName, $filter('number')(discountPct, 2));
        }

        function calculateAmortizationSchedules(
            price,
            invoiceDate,
            amortizationScheduleTemplate) 
        {
            let amortizationSchedules = [];
            let remainingAmount = price;
            let rollUpAmount = 0;
            
            let byIssueDateOrder = _.map(_.sortBy(_.map(amortizationScheduleTemplate, (x) => { return {
                actualIssueDate: x.issueAt != null
                    ? moment(x.issueAt).startOf('day').toDate()
                    : moment(invoiceDate).add(x.issueDaysAfterRegistration, 'days').startOf('day').toDate(),
                item: x
            }}), ['actualIssueDate']), (x) => x.item);
            
            for (let idx = 0; idx < byIssueDateOrder.length; idx++) {
                let isLast = (idx + 1) === byIssueDateOrder.length;
                let amortizationTemplateItem = byIssueDateOrder[idx];

                let amortizationPartAmount = amortizationTemplateItem.amount != null
                    ? Math.min(amortizationTemplateItem.amount, remainingAmount)
                    : Math.min(price * (amortizationTemplateItem.percentageAmount / 100), remainingAmount);

                if (isLast) {
                    amortizationPartAmount = remainingAmount;
                }

                if (amortizationPartAmount <= 0) {
                    break;
                }

                let issueAt = amortizationTemplateItem.issueAt != null
                    ? moment(amortizationTemplateItem.issueAt).startOf('day').toDate()
                    : moment(invoiceDate).add(amortizationTemplateItem.issueDaysAfterRegistration, 'days').startOf('day').toDate();

                if (moment(issueAt).isBefore(moment(invoiceDate).startOf('day'))) {
                    rollUpAmount += amortizationPartAmount;
                    continue;
                }

                let existingAmortizationScheduleIndex =_.findIndex(amortizationSchedules, (n) => moment(n.issueAt).isSame(issueAt));
                if (existingAmortizationScheduleIndex !== -1) {
                    let existingAmortizationScheduleAmount =
                        amortizationSchedules[existingAmortizationScheduleIndex].amount;
                    let amortizationSchedule = {
                        issueAt: issueAt,
                        dueDate: moment(issueAt).add(15, 'days').toDate(),
                        amount: Math.min(amortizationPartAmount + rollUpAmount, remainingAmount) + existingAmortizationScheduleAmount
                    }
                    amortizationSchedules.splice(existingAmortizationScheduleIndex, 1);
                    amortizationSchedules.push(amortizationSchedule);
                    rollUpAmount = 0;
                    remainingAmount -= amortizationSchedule.amount - existingAmortizationScheduleAmount;
                }
                else
                {
                    let amortizationSchedule = {
                        issueAt: issueAt,
                        dueDate: moment(issueAt).add(15, 'days').toDate(),
                        amount: Math.min(amortizationPartAmount + rollUpAmount, remainingAmount)
                    }
                    amortizationSchedules.push(amortizationSchedule);
                    rollUpAmount = 0;
                    remainingAmount -= amortizationSchedule.amount;
                }
            }                
            
            if (amortizationSchedules.length > 0) {
                // Check the sum
                // This can happen if there are some schedules with conflicting issue dates
                let sum = _.reduce(amortizationSchedules, function (sum, n) { return sum += n.amount }, 0);
                let diff = price - sum;
                if (diff > 0) {
                    _.last(amortizationSchedules).amount += diff;
                }
            }

            return amortizationSchedules;
        }

        return {
            getPriceDetails: getPriceDetails,
            getCourseBasePrice: getCourseBasePrice,
            getCourseFeeLineName: getCourseFeeLineName,
            gtDiscountLineStr: gtDiscountLineStr,
            calculateAmortizationSchedules: calculateAmortizationSchedules
        }
    }]);